module.exports = __webpack_public_path__ + "274fffd46e41a0ac76f36497e14b7fdd.svg";